import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useState } from "react";
import { resendTAInQueue } from "services/data.outbound.service";
import { waveUnallocate } from "services/data.outbound.service";
import { getTAInQueue } from "services/data.outbound.service";
import { LoadingDialog } from "ui-components/Alert";
import BasicTable from "ui-components/tables/BasicTable";

function AllocationQueue({ customerCode }) {
  const [listInQueue, setListInQueue] = useState([]);

  const queryClient = useQueryClient();

  const { isFetching } = useQuery({
    queryKey: ["task-in-queue", { customerCode }],
    queryFn: () => getTAInQueue({ customerCode }),
    enabled: customerCode !== null,
    onSuccess: (data) => setListInQueue(data.data.data),
  });

  const resendMutation = useMutation(resendTAInQueue, {});

  const resendStatus = resendMutation.status === "loading";

  const unallocateMutation = useMutation(waveUnallocate, {});

  const unallocateStatus = unallocateMutation.status === "loading";

  const columns = [
    {
      accessorKey: "custOrdNbr",
      header: "Cust Order Number",
      width: 200,
    },
    {
      accessorKey: "orderNumber",
      header: "Order Number",
      width: 200,
    },
    {
      accessorKey: "waveNumber",
      header: "Wave Number",
      width: 200,
    },
    {
      accessorKey: "customerCode",
      header: "Customer Code",
      width: 200,
    },
    {
      accessorKey: "userId",
      header: "RF User Id",
      width: 200,
    },
    {
      accessorKey: "status",
      header: "Status",
      width: 100,
    },
    {
      accessorKey: "createdOn",
      header: "Created On",
      width: 200,
    },
    {
      accessorKey: "action",
      header: "Action",
      enableColumnFilter: false,
      width: 100,
      cell: ({ row }) => {
        const { id, resend } = row.original;
        if (resend) {
          return (
            <>
              <MDButton
                variant="gradient"
                color="info"
                size="small"
                onClick={() => {
                  resendMutation.mutate(
                    { id, customerCode },
                    {
                      onSuccess: () => {
                        queryClient.invalidateQueries(["task-in-queue"]);
                      },
                    }
                  );
                }}
              >
                Resend
              </MDButton>
              <MDButton
                variant="gradient"
                color="error"
                size="small"
                onClick={() => {
                  unallocateMutation.mutate(
                    { queueId: id },
                    {
                      onSuccess: () => {
                        queryClient.invalidateQueries(["task-in-queue"]);
                      },
                    }
                  );
                }}
              >
                Unallocate
              </MDButton>
            </>
          );
        }
        return <div></div>;
      },
    },
    {
      accessorKey: "message",
      header: "Message",
    },
  ];

  return (
    <>
      {(isFetching || resendStatus || unallocateStatus) && <LoadingDialog />}
      <MDBox mt={4}>
        <BasicTable data={listInQueue} columns={columns} />
      </MDBox>
    </>
  );
}

export default AllocationQueue;
